import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { makeStyles } from "@material-ui/core/styles";
import Avatar from "@material-ui/core/Avatar";
import Box from "@material-ui/core/Box";
import Container from "@material-ui/core/Container";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import Typography from "@material-ui/core/Typography";

import { ADM_AREAS_LATEST_COMMENTS_URL } from "../../config";
import makeApiRequest from "../../utils/axios/new-axios";
import { showErrorAlert } from "../../store/actions/alerts";
import ComponentLoader from "../../components/loader/ComponentLoader";
import { usePageTitle } from "../../utils/pageTitle";
import UserChip from "../../components/user/UserChip";
import { fromUnixtime } from "../../utils/time";
import { admAreaUrl, mediaThumbnailUrl } from "../../utils/url";

const useStyles = makeStyles(theme => ({
    paper: {
        width: "100%",
        overflowX: "auto",
        marginBottom: theme.spacing(2),
        padding: "15px"
    }
}));

export default function CommentsList() {
    const classes = useStyles();
    const dispatch = useDispatch();
    usePageTitle("Latest Adm Area Comments");

    const [comments, setComments] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        makeApiRequest({
            url: ADM_AREAS_LATEST_COMMENTS_URL.url,
            method: ADM_AREAS_LATEST_COMMENTS_URL.method,
        }).then(response => {
            setComments(response.data);
            setIsLoading(false);
        }).catch((error) => {
            setIsLoading(false);
            dispatch(
                showErrorAlert(
                    "Fetch Error : " +
                    (!!error.response
                        ? `${error.response.status}! - ${error.response.data.errorMessage}`
                        : error.message)
                )
            );

        })
        // eslint-disable-next-line
    }, []); // [] is required to make sure that it runs only once


    return (
        <Container style={{ marginTop: "20px", padding: "10px" }}>
            <h3> Adm Area Comments - Latest </h3>
            <ComponentLoader isLoading={isLoading} />
            {!isLoading &&
                <>
                    {comments && comments.length > 0 ? (
                        <Paper className={classes.paper}>
                            <Table className={classes.table} size="small">
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Adm Area</TableCell>
                                        <TableCell>Comment</TableCell>
                                        <TableCell>User</TableCell>
                                        <TableCell>Commented On</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {comments.map(com => {
                                        return (
                                            <TableRow key={com.admId}>
                                                <TableCell>
                                                    <Link
                                                        href={`${admAreaUrl(com.admId, com.name, true)}#comments`}
                                                        underline="none"
                                                        target={"_blank"}
                                                    >
                                                        <Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
                                                            <Avatar
                                                                alt={com.name}
                                                                src={mediaThumbnailUrl(com.mediaId, 120)}
                                                                variant="square"
                                                                style={{
                                                                    width: 40,
                                                                    heigth: 40
                                                                }}
                                                            />
                                                            <Typography style={{
                                                                marginLeft: 12
                                                            }}> {com.name}</Typography>

                                                        </Box>
                                                    </Link>
                                                </TableCell>
                                                <TableCell>{com.comment}</TableCell>
                                                <TableCell>
                                                    {!!com.user && (<UserChip
                                                        user={{
                                                            id: com.user.id,
                                                            name: com.user.name,
                                                            username: com.user.username,
                                                            type: 2
                                                        }}
                                                    />)}

                                                </TableCell>
                                                <TableCell>{fromUnixtime(com.commentedOn)}</TableCell>
                                            </TableRow>
                                        )
                                    })}

                                </TableBody>
                            </Table>
                        </Paper>
                    ) : (
                        <Typography align="center">No comments found !!</Typography>
                    )}
                </>
            }
        </Container>
    )
}
